import { createIcon } from '@chakra-ui/react';

const ChevronLeft = createIcon({
  displayName: 'ChevronLeft',
  viewBox: '0 0 9 14',
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.2098 0.430097C7.803 0.023301 7.14345 0.023301 6.73666 0.430097L0.166754 7L6.73666 13.5699C7.14345 13.9767 7.803 13.9767 8.2098 13.5699C8.61659 13.1631 8.61659 12.5036 8.2098 12.0968L3.11303 7L8.2098 1.90324C8.61659 1.49644 8.61659 0.836893 8.2098 0.430097Z"
        fill="white"
      />
    </>
  ),
});

export default ChevronLeft;
